/* eslint-disable */
import React, {useContext, useEffect, useState} from "react";
import "./index.css";
import MyContext from "../../components/Mycontext";

// import logo from "../../../static/logo.png";

import refresh from "../../../static/icon/refresh.svg";
import ChatList from "../../components/ChatList";
import chatList from "../../components/ChatList";
import {Spinner} from "react-bootstrap";
import {Button} from "antd";
import {useNavigate, useParams} from "react-router-dom";
import {TASK_TYPE, TaskType} from "../../../config";
import {useAuth} from "../../../providers/AuthProvider";
import {useTranslation} from "react-i18next";
import {useTheme} from "../../../providers/CustomThemeProvider";
import Headers from "../../components/Headers";

function DoctaAiChat(props: any) {
	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const {
		selectedChat,
		conversationId,
		setSelectedChat,
		setIsInputValue,
		setConversationId,
		isLoad,
		isInputValue,
		sessionId,
		file,
		setFile,
		fileUrl,
		setFileUrl,
		requireType,
		message,
		sendMessage,
		streamMessages,
		save,
		addSession,
		handleChange,
		messageId,
		current,
		setCurrent,
		needFresh,
		setNeedFresh,
		getConversationList,
		isLoading
	} = context;
	const { isDarkMode, switchTheme } = useTheme();
	const { id: convId } = useParams<{ id: string }>(); // 获取 id 参数

	const typeMap = [
		TASK_TYPE.LANGUAGE_SAFETY,
		TASK_TYPE.QUERY_DATA,
		TASK_TYPE.CHECK_LABEL,
		TASK_TYPE.LOW_QUALITY_DETECTION,
	];

	const userdetail = useAuth();
	const user = userdetail?.userInfo;

	const [taskType, setTaskType] = useState<TaskType>(
		typeMap[selectedChat?.type ?? 1]
	);

	useEffect(() => {
		console.log("=========selectedChat ", sessionId, selectedChat);
		setTaskType(typeMap[selectedChat?.type ?? 1]);
		// if (conversationId !== 0) {
		// 	setTaskType(typeMap[selectedChat?.type ?? 0]);
		// }
	}, [selectedChat]);

	const [show, setShow] = useState(false);
	const [showBalance, setShowBalance] = useState(false);

	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const handleClose = () => setShow(false);

	const refreshCallback = () => {
		// seleConversation(selectedChat?.id ?? conversationId);
		getConversationList(selectedChat?.id ?? conversationId);
	};

	useEffect(() => {
		if (needFresh) {
			refreshCallback();
			setNeedFresh(false);
		}
	}, [needFresh]);

	useEffect(() => {
		// if (streamMessages && selectedChat?.type == 1) {
		if (streamMessages) {

			const data = JSON.parse(JSON.stringify(selectedChat));

			console.log(
				"======streamMessages===========",
				streamMessages,
				selectedChat?.type,
				messageId,
				data.id,
				conversationId
			);
			if (data.id !== messageId) {
				return;
			}
			// setIsInputValue(false);
			const newData = JSON.parse(JSON.stringify(selectedChat));
			// if (conversationId !== data?.id) {
			// 	seleConversation(Number(data.id));
			// 	if (user && user?.userId) {
			// 		setSelectedChat(newData);
			// 	}
			// } else {
			if (streamMessages.length === 0) {
				return;
			}
			setCurrent(streamMessages);
			// }
			// setInputValue(String(new Date().getTime()));
			return;
		} else {
			const data = JSON.parse(JSON.stringify(selectedChat));

			if (data.id !== messageId) {
				return;
			}
			seleConversation(Number(data.id));
		}
	}, [streamMessages, message]);

	/* 选择聊天记录 */
	const seleConversation = (id: any) => {
		// setCurrent([]);

		if (!id) {
			return;
		}
		navigate(`/d5data/c/${id}`);
		// setIsLoad(true);
		// setIsInputValue(false);
		// if (id) {
		// 	getConversationList(id);
		// }
	};

	return (
		<div className="doctaChat">
			<Headers />

			{/* 加载遮罩层 */}
			{isLoad ? (
				<div className="doctaChat-mask">
					<Spinner />
				</div>
			) : (
				<></>
			)}
			<ChatList
				refreshCallback={refreshCallback}
				onChange={handleChange}
				file={file}
				setFile={setFile}
				fileUrl={fileUrl}
				setFileUrl={setFileUrl}
			/>

			{/* 加载动画 */}
			{isLoading ? (
				<div className="chatList-refresh">
					<img src={refresh} />
					{/* Regenerate response */}
					正在搜索数据...
				</div>
			) : (
				<></>
			)}
		</div>
	);
}

export default DoctaAiChat;
